// extracted by mini-css-extract-plugin
export default {"root":"root--X0WM4","table":"table--wHt56"};